// extracted by mini-css-extract-plugin
module.exports = {"sociometryAnnulResultModal":"SociometryAnnulResultModal_sociometryAnnulResultModal__3mkIk","closeButton":"SociometryAnnulResultModal_closeButton__UZF4V"};